import { EventbriteServiceComponent } from './EventbriteServiceComponent';
export const EventbriteReconnectionConfig = {
  reconnectButton: null,
  serviceComponent: EventbriteServiceComponent
};